const RepairFilePricingTypeConstant = {
  ESTIMATE: 'ESTIMATE',
  PACKAGE: 'PACKAGE'
}

export default RepairFilePricingTypeConstant
